import en from "shared/localization/english";
import { LanguageService } from "./language.service";

export class TutorailNameSerivce {
    public static changeName(mechanic) {
        const names = {
            fillBar: LanguageService.getTranslation('loc_tutorial_name_fillBar'),
            backgroundRelease: LanguageService.getTranslation('loc_tutorial_name_background_release'),
            dropProduct: LanguageService.getTranslation('loc_tutorial_name_drop_product')
        }
        const tag = document.getElementById('tutorial_name');
        tag.innerHTML = names[mechanic];
    }
}